<div style="margin-bottom: 5px;">
    <div>
        <dx-text-box #selectVoucher width="100%" placeholder="Enter Voucher Code"                        
            (onInput)="onSelectedVoucherChanged($event)"
            >
        </dx-text-box>
        <div class="small">    
            The voucher code must contain only numbers, upper case letters and dashes. It must be between 5 and 50
            characters long.
        </div>
    </div>
</div>